import React, { FC } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import styled from 'styled-components';

import { useMarketplaceBreadcrumbs } from '../../hooks/useMarketplaceBreadcrumbs';
import { Breadcrumbs } from '../Breadcrumbs';
import { NavigationBar } from '../NavigationBar';
import { useCaptureUTMParams } from '../../utils/attribution_tracking';

/*
 * Types.
 */

interface MarketplaceLayoutProps {}

/*
 * Constants.
 */

const StyledOutletDiv = styled.div``;

const PageContainer = styled.div`
  background-color: white;
`;

/*
 * Component.
 */

export const MarketplaceLayout: FC<MarketplaceLayoutProps> = () => {
  useCaptureUTMParams();
  const { marketplaceBreadcrumb } = useMarketplaceBreadcrumbs();
  const { spaceSlug } = useParams();

  return (
    <PageContainer>
      <NavigationBar>
        {marketplaceBreadcrumb && (
          <Breadcrumbs
            breadcrumb={marketplaceBreadcrumb}
            page={spaceSlug ? 'space' : 'venue'}
          />
        )}
      </NavigationBar>
      <StyledOutletDiv>
        <Outlet />
      </StyledOutletDiv>
    </PageContainer>
  );
};
